import { createApiClient } from 'sly/services/api';
import apiEndpoints from 'sly/services/api/endpoints';
import StaticPages from 'sly/sitemap/components/StaticPages';

export default StaticPages;

export const getServerSideProps = async () => {
  const { api, store } = createApiClient(apiEndpoints);

  await Promise.allSettled(
    [api.getHubPage.asAction(), api.getMarketingPage.asAction()].map(
      store.dispatch
    )
  );

  return {
    props: {
      initialApiState: store.getState(),
    },
  };
};
